import { render } from "./registerPage.vue?vue&type=template&id=55f702d2&scoped=true"
import script from "./registerPage.vue?vue&type=script&lang=js"
export * from "./registerPage.vue?vue&type=script&lang=js"

import "./registerPage.vue?vue&type=style&index=0&id=55f702d2&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-55f702d2"]])

export default __exports__